import ApiClient from './ApiClient';

// "Meus blocos" do editor de e-mail: get(), create({ name, kind, node }),
// update(id, { name }), delete(id) vêm do ApiClient.
class EmailSavedBlocksAPI extends ApiClient {
  constructor() {
    super('email_saved_blocks', { accountScoped: true });
  }
}

export default new EmailSavedBlocksAPI();
